import { ResumePetisSimulationProposalClientResponse } from '../../../@types/ResumePetisSimulationProposal'
import {
  DiscountCampaings,
  RunPetisSimulationClientResponse,
} from '../../../@types/RunPetisSimulation'
import { useRunPetisSimulationStore } from '../../../Stores/useRunPetisSimulationStore'
import { QUOTATION_STATUS_CODE } from '../../../constants/quotationStatusCode'
import { REFERRALS } from '../../../constants/referrals'

export const useRunPetisSimulationHydration = () => {
  const {
    setRunPetisSimulation,
    setIsReferral,
    setIsReferralWarning,
    setSelectedPackCampaign,
    setPacksCampaigns,
  } = useRunPetisSimulationStore()

  const handleRunPetisSimulationHydrate = (
    data: ResumePetisSimulationProposalClientResponse,
  ) => {
    const referrals =
      data.processData?.simulationData?.runPetisSimulationClientResponse
        ?.runPetisSimulationResponse?.referrals

    const hasQuotationAccepted =
      data.processData?.quotationData?.status === QUOTATION_STATUS_CODE.AC

    setIsReferral((referrals || [])?.length > 0 && !hasQuotationAccepted)

    const outcomeTypeCode = referrals?.map(
      (referral) => referral.outcomeTypeCode,
    )
    setIsReferralWarning((outcomeTypeCode || [])?.includes(REFERRALS.warning))

    setRunPetisSimulation({
      ...(data.processData?.simulationData
        ?.runPetisSimulationClientResponse as RunPetisSimulationClientResponse),
      discountsCampaigns: data.processData?.simulationData?.discountCampaigns,
    })

    setPacksCampaigns(data.processData?.simulationData?.discountCampaigns || [])

    setSelectedPackCampaign(
      (data.processData?.simulationData
        ?.associatedDiscounts?.[0] as DiscountCampaings) || null,
    )
  }

  return { handleRunPetisSimulationHydrate }
}
